import { render, staticRenderFns } from "./LawStatisticGraphicCustom.vue?vue&type=template&id=7c367abc&scoped=true"
import script from "./LawStatisticGraphicCustom.vue?vue&type=script&lang=js"
export * from "./LawStatisticGraphicCustom.vue?vue&type=script&lang=js"
import style0 from "./LawStatisticGraphicCustom.vue?vue&type=style&index=0&id=7c367abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c367abc",
  null
  
)

export default component.exports